import { Panel } from "./Panel";
import { RateInput } from "./RateInput";
import { getIn } from "./ratePaths";

/** A grid of fees where both the rows and the columns are named factors. */
export const MatrixEditor = ({ service, matrix, draft, onChange }) => (
  <Panel
    title={matrix.title}
    help={matrix.help}
    testId={`rate-card-matrix-${service}-${matrix.path}`}
  >
    <div className="overflow-x-auto rounded-lg border border-border">
      <table className="w-full border-collapse text-sm">
        <thead className="bg-[color:var(--tt-teal-mist)]">
          <tr>
            <th className="min-w-[220px] px-3 py-2 text-left text-[11px] font-bold uppercase tracking-[0.08em] text-[color:var(--tt-teal-deep)]">
              Factor
            </th>
            {matrix.columns.map((column) => (
              <th
                key={column.key}
                className="w-[180px] px-3 py-2 text-left text-[11px] font-bold uppercase tracking-[0.08em] text-[color:var(--tt-teal-deep)]"
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {matrix.rows.map((row) => (
            <tr key={row.key} className="hover:bg-[color:var(--tt-surface-2)]">
              <td className="px-3 py-2 text-[13px] font-medium text-foreground">{row.label}</td>
              {matrix.columns.map((column) => {
                const path = `${service}.${matrix.path}.${row.key}.${column.key}`;
                return (
                  <td key={column.key} className="px-3 py-2">
                    <RateInput
                      testId={`rate-input-${path}`}
                      ariaLabel={`${row.label} — ${column.label}`}
                      kind={column.type}
                      value={getIn(draft, path)}
                      onChange={(value) => onChange(path, value)}
                    />
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Panel>
);
